import {
  zlbApiExpenseOvertimeNightMealFeeListPost,
  zlbApiExpenseOvertimeNightMealFeeDetailGet,
  // 提交任务
  zlbApiExpenseImportsSubmitPost,
  // 解析任务
  zlbApiExpenseImportsResultPost,
  // 确认导入
  zlbApiExpenseImportsOverTimeConfirmPost,
} from '@/api/zlbExpense';

export default {
  namespace: 'overtimeManage',
  state: {
    overtimeDetail: {},
  },
  effects: {
    /**
     * 夜餐费明细
     * @param {*} param0 
     * @param {*} param1 
     * @returns 
     */
    * getDinnerFeeDetailsList ({ payload }, { call }) {
      const res = yield call(zlbApiExpenseOvertimeNightMealFeeListPost, payload);
      return res;
    },
    /**
     * 夜餐费明细详情
     */
    * getDinnerFeeDetailsDetail ({ payload }, { call, put }) {
      const res = yield call(zlbApiExpenseOvertimeNightMealFeeDetailGet, payload);
      yield put({
        type: 'update',
        payload: {
          overtimeDetail: res,
        },
      });
      return res;
    },
    * commitUpload ({ payload }, { call }) {
      const res = yield call(zlbApiExpenseImportsSubmitPost, payload);
      return res;
    },
    * pollingQueryRes ({ payload }, { call }) {
      const res = yield call(zlbApiExpenseImportsResultPost, payload);
      return res;
    },
    * confirmImport ({ payload }, { call }) {
      const res = yield call(zlbApiExpenseImportsOverTimeConfirmPost, payload);
      return res;
    }
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
